import { render, staticRenderFns } from "./addget.vue?vue&type=template&id=18d8c1a3&scoped=true&"
import script from "./addget.vue?vue&type=script&lang=js&"
export * from "./addget.vue?vue&type=script&lang=js&"
import style0 from "./addget.vue?vue&type=style&index=0&id=18d8c1a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8c1a3",
  null
  
)

export default component.exports